import { useAnimatedDisclosure } from '@hooks/useAnimatedDisclosuer';
import React, { useContext, useEffect, useState } from 'react';

export const RegisterPopupVisibilityContext = React.createContext(undefined);

export const RegisterPopupVisibilityProvider = ({ children }) => {
  const { isOpen, onOpen, onClose, isMounted } = useAnimatedDisclosure(500);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  const {
    isOpen: isFaqOpen,
    onOpen: onFaqOpen,
    onClose: onFaqClose,
    isMounted: isFaqMounted,
  } = useAnimatedDisclosure(500);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 1700);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <RegisterPopupVisibilityContext.Provider
      value={{
        isOpen,
        onOpen,
        onClose,
        isMounted,
        isFaqOpen,
        onFaqOpen,
        onFaqClose,
        isFaqMounted,
        isLargeScreen,
        setIsLargeScreen,
      }}
    >
      {children}
    </RegisterPopupVisibilityContext.Provider>
  );
};

export const useRegisterPopupVisibilityContext = () => {
  const contextValue = useContext(RegisterPopupVisibilityContext);

  if (!contextValue)
    throw new Error(
      'useProgramLanguageSelection needs to be used with LanguageContext'
    );

  return contextValue;
};
